<template>
	<NuxtLink
		ref="nuxtLinkContent"
		:external="link.isExternal === undefined ? true : link.isExternal"
		:to="link.url"
		:class="[$style.link, variant === 'dim' && $style.dim]"
		:rel="rel"
		:target="target"
		@click="handleClick"
	>
		<slot />
	</NuxtLink>
</template>

<script lang="ts" setup>
import type { CommonLinkProps } from './common-link-types';
import { NuxtLink } from '#components';

const props = withDefaults(defineProps<CommonLinkProps>(), {
	variant: 'default',
	trackingLabel: undefined,
	analyticsContext: undefined,
});

const { trackLinkClick } = useNloGtm();

const nuxtLinkContent = ref<InstanceType<typeof NuxtLink>>();

const rel = computed(() => {
	return `${props.link.targetIsBlank ? 'noopener noreferrer' : ''} ${props.link.noFollow ? 'nofollow' : ''}`.trim();
});

const target = computed(() => {
	return props.link.targetIsBlank ? '_blank' : undefined;
});

const handleClick = () => {
	const label = props.trackingLabel ?? nuxtLinkContent.value?.$el.innerText ?? '';
	trackLinkClick(label, props.analyticsContext);
};
</script>

<style lang="scss" module>
.link {
	cursor: pointer;
	color: var(--link--link);
	font-weight: var(--typography--semibold);
	text-decoration: underline;

	&:focus {
		color: var(--link--link-hover);
	}

	&:hover {
		color: var(--link--link-hover);
	}
}

.dim {
	color: var(--link--link-dim);

	&:focus {
		color: var(--link--link-dim-hover);
	}

	&:hover {
		color: var(--link--link-dim-hover);
	}
}
</style>
